/**
 * Loại value của option
 */
export const OptionValueType = {
  /**
   * Boolean
   */
  Bool: 1,

  /**
   * string
   */
  String: 2,

  /**
   * object
   */
  Object: 3,

  // Ko có number?
}